import { Button } from "@components/atoms/Button"
import { Heading } from "@components/atoms/Heading"
import { Typography } from "@components/atoms/Typography"
import { VSpace } from "@components/layout/Spacer"
import { useForm } from "@hooks/queries"
import { useSignup } from "@hooks/useSignup"
import { cn } from "@utils/tw"
import { useHydrating } from "eddev/routing"
import { useEffect, useRef, useState } from "react"

export const SignupForm = ({ fueltrack }: { fueltrack?: boolean }) => {
  const form = useForm({ id: fueltrack ? "3" : "2" })
  const hydrating = useHydrating()

  if (!hydrating && form.data?.gravityForm?.form)
    return (
      <>
        <div className="w-full bg-black rounded-md p-6 my-3 text-white md:flex md:items-center md:gap-5">
          <div>
            <Heading as="h3" variant="h3">
              {form.data.gravityForm.form.title}
            </Heading>
            {form.data.gravityForm.form.description !== "" && (
              <>
                <VSpace initial={4} />
                <Typography variant="text-m">{form.data.gravityForm.form.description}</Typography>
              </>
            )}
          </div>
          <SignupTrigger />
        </div>
      </>
    )
}

export const SignupTrigger = ({ black }: { black?: boolean }) => {
  const inputRef = useRef<HTMLInputElement>(null)
  const showSignup = useSignup()

  const [showButton, setShowButton] = useState<boolean>(false)
  useEffect(() => {
    if (inputRef.current) setShowButton(true)
  }, [inputRef])

  return (
    <div
      className={cn(
        "flex flex-col gap-4 justify-between w-full mt-4 sm:flex-row sm:items-end lg:w-[calc((100%-var(--spacing-5))*(6/12))]",
        "[&>div]:flex [&>div]:flex-col [&>div]:grow",
        "[&_label]:type-label-caps [&_label]:mb-1",
        "[&_input]:type-label-m [&_input]:px-3 [&_input]:py-4 [&_input]:rounded-[6px] [&_input]:border-none [&_input]:h-[42px] [&_button]:h-[42px] [&_button]:!py-0 [&_button]:!px-4 [&_button]:!justify-between [&_button_span]:!grow-0",
        "[&_input]:shadow-[inset_0px_0px_0px_1px_#ffffff] [&_input:focus]:shadow-[inset_0px_0px_0px_2px_#FEC32C]",
      )}
    >
      <div className="flex flex-col gap-3 md:gap-2">
        <label htmlFor="initial">Email*</label>
        <input type="text" id="initial" ref={inputRef} />
      </div>
      {showButton && (
        <Button
          color={black ? "black" : "yellow"}
          size="medium"
          icon="ARROW_RIGHT"
          iconStyle="left"
          onClick={() => {
            showSignup.setOpen(true)
            showSignup.setValue(inputRef.current?.value ?? "")
          }}
        >
          Next
        </Button>
      )}
    </div>
  )
}
